module.exports = __webpack_public_path__ + "img/climate_actions_energyscouts@2x.b9ae64a.webp";